/* PrintShell — adds the BharatCart family-photo watermark + logo + tagline
   header to any printable document (orders, bills, tickets, scratch cards).
   The shell is INVISIBLE on screen; it ONLY renders when the user prints
   the page (Ctrl/Cmd-P or via the in-page "Print" button). */
import { Printer } from 'lucide-react';

export function PrintShell({ kind = 'Document', docId = '', dateText = '' }) {
  return (
    <>
      {/* Family-photo watermark — invisible on screen, visible behind every printed page */}
      <img
        src="/family-hero.png"
        alt=""
        aria-hidden="true"
        className="mandispot-print-watermark"
      />
      <header className="print-shell" aria-hidden="true">
        <div>
          <div className="print-brand-name">BharatCart</div>
          <div className="print-brand-tagline">Your village shop, online — सबका bazaar, ek tap par.</div>
        </div>
        <div className="print-doc-title">
          <div className="print-doc-kind">{kind}</div>
          {docId && <div className="print-doc-id">{docId}</div>}
          {dateText && <div className="print-doc-date">{dateText}</div>}
        </div>
      </header>
    </>
  );
}

export function PrintButton({ label = 'Print', testId = 'print-doc-btn' }) {
  return (
    <button
      data-testid={testId}
      onClick={() => window.print()}
      className="no-print inline-flex items-center gap-1.5 rounded-full border border-border bg-white text-ink/80 hover:border-[#E67E22] hover:text-[#D35400] px-3 py-1.5 text-xs font-semibold transition"
      type="button"
    >
      <Printer className="w-3.5 h-3.5"/> {label}
    </button>
  );
}
